export default {
    fontFamilyHeader: "'Georgia', 'serif'",
    fontFamilyBody: "'Times New Roman', 'Georgia', 'serif'",
    fontFamilyBodyMonospaced: "'Courier', 'Lucida Console', 'monospace'",
    fontBold: 700,
};
